'use es6';

import withDebouncedInput from 'ContentComponents/decorators/withDebouncedInput';
import { ThemeSortingTypes } from 'ContentUtils/constants/ThemeSortingTypes';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SearchInput as FoundationsSearchInput } from 'foundations-components/transitional/components/SearchInput';
import UISelect from 'UIComponents/input/UISelect';
import UIToolBar from 'UIComponents/nav/UIToolBar';
import UIToolBarGroup from 'UIComponents/nav/UIToolBarGroup';
import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.themes.filterBar.${key}`;
const DebouncedSearchInput = withDebouncedInput(FoundationsSearchInput);
export const SortFilter = ({
  sortType,
  onSortingChange
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('sortLabel')
  }), /*#__PURE__*/_jsx(UISelect, {
    buttonUse: "link",
    className: "m-left-2",
    value: sortType,
    options: [{
      text: I18n.text(i18nKey('sortTypes.mostUsed')),
      value: ThemeSortingTypes.MOST_USED
    }, {
      text: I18n.text(i18nKey('sortTypes.alphabetical')),
      value: ThemeSortingTypes.ALPHABETICAL
    }],
    onChange: onSortingChange
  })]
});
export const SearchInput = ({
  placeholder,
  onChange,
  searchValue
}) => /*#__PURE__*/_jsx(DebouncedSearchInput, {
  placeholder: placeholder,
  onChange: onChange,
  value: searchValue
});
export const FilterBar = ({
  searchInput,
  sortFilter,
  sourceFilter = null,
  templateFolderFilter = null
}) => /*#__PURE__*/_jsxs(UIToolBar, {
  className: "m-top-0",
  use: "filter-bar",
  children: [/*#__PURE__*/_jsxs(UIToolBarGroup, {
    children: [sortFilter, sourceFilter, templateFolderFilter]
  }), /*#__PURE__*/_jsx(UIToolBarGroup, {
    children: searchInput
  })]
});